import * as DefaultFilterNames from 'SalesContentIndexUI/data/lib/DefaultFilterNames';
import { UserViewFilter } from 'SalesContentIndexUI/data/utils/viewFilters/UserViewFilter';
import { TeamViewFilter } from 'SalesContentIndexUI/data/utils/viewFilters/TeamViewFilter';
import * as FilterTypes from 'SalesContentIndexUI/data/lib/FilterTypes';
const parseSelection = selectedViewFilterId => {
  const userAndTeamRegExp = /(USER|TEAM)-(\d+)/;
  return userAndTeamRegExp.test(selectedViewFilterId) ? {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    id: Number(userAndTeamRegExp.exec(selectedViewFilterId)[2]),
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    view: userAndTeamRegExp.exec(selectedViewFilterId)[1]
  } : {
    view: selectedViewFilterId
  };
};
export default (({
  viewFilters,
  currentViewFilterName,
  isModal,
  looseItemContentType,
  folderContentType
}) => {
  if (currentViewFilterName) {
    const {
      id,
      view
    } = parseSelection(currentViewFilterName);
    if (!id) {
      return viewFilters.get(view);
    }
    const ViewFilter = view === FilterTypes.USER ? UserViewFilter : TeamViewFilter;
    return ViewFilter({
      looseItemContentType,
      folderContentType,
      id
    });
  }
  return isModal ? viewFilters.get(DefaultFilterNames.CREATED_BY_ME) : viewFilters.get(DefaultFilterNames.ALL);
});